var touch = false, clickEv = 'click', checkDropdown = [], checkSideMenu = [], checks_scroll = 0;  ;

/* slider product*/
function sliderProduct(){
  /* Home1 */
  /* slides block products */
  if($(".home_latestproducts_content").length){
    $(".home_latestproducts_content").owlCarousel({
      navigation : true,
      pagination: false,
      autoPlay: false,
      items: 4,
      slideSpeed : 200,
      paginationSpeed : 800,
      rewindSpeed : 1000,
      itemsDesktop : [1199,3],
      itemsDesktopSmall : [991,2],
      itemsTablet: [767,2],
      itemsTabletSmall: [540,1],
      itemsMobile : [360,1]
    });
  }
  /* Slider Thumb */
  if($(".slider-3itemsc").length){
    $(".slider-3itemsc").owlCarousel({
      navigation : true,
      pagination: false,
      autoPlay: false,
      items: 3,
      slideSpeed : 200,
      paginationSpeed : 800,
      rewindSpeed : 1000,
      itemsDesktop : [1199,3],
      itemsDesktopSmall : [991,3],
      itemsTablet: [767,4],
      itemsTabletSmall: [540,3],
      itemsMobile : [420,2]
    });
  }
  $(".show-load-detail").css("display", "none");
  
  /* Slider Relatedpro */
  if($(".related-products-full .rp-slider").length){
    $(".related-products-full .rp-slider").owlCarousel({
      navigation : true,
      pagination: false,
      items: 4,
      slideSpeed : 200,
      paginationSpeed : 800,
      rewindSpeed : 1000,
      itemsDesktop : [1920,4],
      itemsDesktopSmall : [1200,4],
      itemsTablet: [1199,4],
      itemsTabletSmall: [991,3],
      itemsMobile : [767,2]
    });
  } 
  if($(".related-products-sidebar .rp-slider").length){
    $(".related-products-sidebar .rp-slider").owlCarousel({
      navigation : true,
      pagination: false,
      items: 4,
      slideSpeed : 200,
      paginationSpeed : 800,
      rewindSpeed : 1000,
      itemsDesktop : [1920,4],
      itemsDesktopSmall : [1400,3],
      itemsTablet: [1199,3],
      itemsTabletSmall: [991,3],
      itemsMobile : [767,2]
    });
  } 

  $(".vertical-slider").bxSlider({
    mode: 'vertical',
    slideWidth: 100,
    minSlides: 4,
    nextText: '<i class="fa fa-angle-up" title="Previous" data-toggle="tooltip" data-placement="top"></i>',
    prevText: '<i class="fa fa-angle-down" title="Next" data-toggle="tooltip" data-placement="top"></i>',
    hideControlOnEnd: true,
    infiniteLoop: false,
    pager: false,
    slideMargin: 0
  });
  
}

/* slider product*/
function sliderBlog(){
  if($(".related-blog-slider").length){
    $(".related-blog-slider").owlCarousel({
      navigation : true,
      pagination: false,
      autoPlay: false,
      items: 1,
      slideSpeed : 200,
      paginationSpeed : 800,
      rewindSpeed : 1000,
      itemsDesktop : [1199,1],
      itemsDesktopSmall : [991,1],
      itemsTablet: [767,1],
      itemsTabletSmall: [540,1],
      itemsMobile : [360,1]
    });
  }
}

/* Handle dropdown box */
function handleDropdown(){
  var changeIcon = function() {
    $( ".dropdownMobile-toggle" ).each(function( index ) {
      $(this).parent().find('.dropdown-menu').hide();
      $(this).removeClass('active-dropdown');
      var icon_class=$(this).find('.icon-dropdown').data('class');
      $(this).find('.icon-dropdown').attr('class','icon-dropdown '+icon_class);
    });
  }
  var dropdownDesktop = function() {
    if($('.dropdown-toggle').length){
      $('.dropdown-toggle').parent().hover(function (){
        if(touch == false && getWidthBrowser() > 767 ){
          $(this).find('.dropdown-menu').stop(true, true).slideDown(300);
        }
      }, function (){
        if(touch == false && getWidthBrowser() > 767 ){
          $(this).find('.dropdown-menu').hide();
        }
      });
    }
  }
  var dropdownTablet = function(){
    if($('.dropdownMobile-toggle').length){
      $('.dropdownMobile-toggle').on('click', function() {
        if(!$(this).hasClass('active-dropdown')){
          changeIcon();
          $('body').addClass('active-overflow');
          $(this).parent().find('.dropdown-menu').stop(true, true).slideDown(300);
          $(this).addClass('active-dropdown');
          $(this).find('.icon-dropdown').attr('class','icon-dropdown cs-icon icon-close');
        }
        else{
          $('body').removeClass('active-overflow');
          changeIcon();
        }
      });
    }
  }
  $('nav .dropdown-menu').each(function(){
    $(this).find('li').last().addClass('last');
  });
  $('.dropdown').on('click', function() {
    if(touch == false && getWidthBrowser() > 767 ){
      var href = $(this).find('.dropdown-link').attr('href');
      window.location = href;
    }
  });
  dropdownDesktop();
  dropdownTablet();
}

/* Fucntion get width browser */
function getWidthBrowser() {
  var myWidth;

  if( typeof( window.innerWidth ) == 'number' ) { 
    //Non-IE 
    myWidth = window.innerWidth;
    //myHeight = window.innerHeight; 
  } 
  else if( document.documentElement && ( document.documentElement.clientWidth || document.documentElement.clientHeight ) ) { 
    //IE 6+ in 'standards compliant mode' 
    myWidth = document.documentElement.clientWidth; 
    //myHeight = document.documentElement.clientHeight; 
  } 
  else if( document.body && ( document.body.clientWidth || document.body.clientHeight ) ) { 
    //IE 4 compatible 
    myWidth = document.body.clientWidth; 
    //myHeight = document.body.clientHeight; 
  }

  return myWidth;
}

// handle scroll-to-top button
function handleScrollTop() {
  function totop_button(a) {
    var b = $("#scroll-to-top"),
        f = $(".cart-float-right");

    if (a == "on") { 
      f.addClass("on fadeInRight ").removeClass("off fadeOutRight");
      b.addClass("on fadeInRight ").removeClass("off fadeOutRight"); 
    } else {
      f.addClass("off fadeOutRight animated").removeClass("on fadeInRight");
      b.addClass("off fadeOutRight animated").removeClass("on fadeInRight"); 
    }
  }
  $(window).scroll(function() {
    var b = $(this).scrollTop();
    var c = $(this).height();
    if (b > 0) { 
      var d = b + c / 2;
    } 
    else { 
      var d = 1 ;
    }    
    if (d < 1e3 && d < c) { 
      totop_button("off");
    } 
    else {
      totop_button("on"); 
    }
  });  
  $("#scroll-to-top").click(function (e) {
    e.preventDefault();
    $('body,html').animate({scrollTop:0},800,'swing');
  });
}   

//newsletter popup
function ModalNewsletter(){
  var showNewsletter = function(date){
    $('#newsletter-popup').modal('toggle');
    $('.nl-wraper-popup').addClass('animated'); 
    var tnout = 120 ;
    setTimeout (function() { 
      $('#newsletter-popup').modal('hide');
    }, tnout*1000 );
    localStorage.setItem('cs-newsletter', date );
  }
  var checkNewsletter = function(){
    var date = '06/24/2026 17:35:00';
    if(localStorage.getItem('cs-newsletter') == null || localStorage.getItem('cs-newsletter') == "undefined" ){
	  showNewsletter(date);
    }
    else{
      var check_time = new Date(date) - new Date(localStorage.getItem('cs-newsletter'));
      var ms = check_time % 1000;
      check_time = (check_time - ms) / 1000;
      var days = Math.floor(check_time / 86400);
      if(days > 7){
        showNewsletter(date);
      }
    }
  }
  
}

/* Handle product quantity */
function handleQuantity(){
  if($('.quantity-wrapper').length){
    $('.quantity-wrapper').on(clickEv, '.qty-up', function() {
      var $this = $(this);

      var qty = $this.parents('.wrapper').find('input');
      $(qty).val(parseInt($(qty).val()) + 1);
    });
    $('.quantity-wrapper').on(clickEv, '.qty-down', function() {
      var $this = $(this);
      var qty = $this.parents('.wrapper').find('input');

      if(parseInt($(qty).val()) > 1)
        $(qty).val(parseInt($(qty).val()) - 1);
    });
  }
}

function colorwarches(){
  jQuery('.swatch :radio').change(function() {
    var optionIndex = jQuery(this).closest('.swatch').attr('data-option-index');
    var optionValue = jQuery(this).val();
    jQuery(this)
    .closest('form')
    .find('.single-option-selector')
    .eq(optionIndex)
    .val(optionValue)
    .trigger('change');
  }); 
}

function toggleTagsFilter(){ 
  if(window.innerWidth >= 768 ){
    var tagsbutton = document.getElementById( 'showTagsFilter' ),    
        tagscontent = document.getElementById( 'tags-filter-content' );    
    if(tagsbutton != null ){
      tagsbutton.onclick = function() {
        classie.toggle( this, 'closed' );
        classie.toggle( tagscontent, 'tags-closed' );
        if(classie.has( this, 'closed' ))
          $('#showTagsFilter').html("Filter <i class='fa fa-angle-down'></i>");
        else $('#showTagsFilter').html("Filter <i class='fa fa-angle-up'></i>");
      };
    }
  }
}

/* Function update scroll product thumbs */
function updateScrollThumbsQS(){
  if($('#gallery_main_qs').length){

    $('#quick-shop-image .fancybox').on(clickEv, function() {
      var _items = [];
      var _index = 0;
      var product_images = $('#gallery_main_qs .image-thumb a');
      product_images.each(function(key, val) {
        _items.push({'href' : val.href, 'title' : val.title});
        if($(this).hasClass('active')){
          _index = key;
        }
      });
      $.fancybox(_items,{
        closeBtn: true,
        index: _index,
        helpers: {
          buttons: {}
        }
      });
      return false;
    });

    $('#quick-shop-image').on(clickEv, '.image-thumb a', function() {

      var $this = $(this);
      var background = $('.product-image .main-image .main-image-bg');
      var parent = $this.parents('.product-image-wrapper');
      var src_original = $this.attr('data-image-zoom');
      var src_display = $this.attr('data-image');

      background.show();

      parent.find('.image-thumb').removeClass('active');
      $this.parent().addClass('active');

      parent.find('.main-image').find('img').attr('data-zoom-image', src_original);
      parent.find('.main-image').find('img').attr('src', src_display).load(function() {
        background.hide();
      });

      return false;
    });
  }
}

//Change Quantity Quick Show
function change_qs_quantity(qs){
  qs_quantity=qs;
}

function showMenuMobile(){
  var changeIconRight = function() {
    $( ".dropdownMobile-toggle" ).each(function( index ) {
      $(this).parent().find('.dropdown-menu').hide();
      $(this).removeClass('active-dropdown');
      var icon_class=$(this).find('.icon-dropdown').data('class');
      $(this).find('.icon-dropdown').attr('class','icon-dropdown '+icon_class);
    });
  }
  var changeIcon = function(){
    $('.navigation_mobile .arrow').removeClass('class_test');
    $('.navigation_mobile .arrow i').attr('class', 'cs-icon icon-ios-plus-empty');
    $('.navigation_mobile').removeClass('active_dropdown');
    $('.navigation_mobile .menu-mobile-container').hide("slow");
  }
  var showMenu = function(){
    $('.group_navbtn_action .dropdown-toggle-navigation').on('click', function() {
      $(this).addClass('active-dropdown');
      $(this).parent().find('.navigation_dropdown_scroll').addClass("hover-dropdown");
    });
  }
  var closeMenu = function(){
    $('.group_navbtn_action .close-navigation-dropdown').on('click', function() {
      $(this).parents('.navigation_dropdown_scroll').removeClass("hover-dropdown");
    });
  }
  var showMegaMenu = function(){
    $('.navigation_mobile .arrow').on('click', function() {
      if($(this).hasClass('class_test')){
        $(this).removeClass('class_test');
        $(this).find('i').attr('class', 'cs-icon icon-ios-plus-empty');
        $(this).parent().removeClass('active_dropdown');
        $(this).parent().find('.menu-mobile-container').hide("slow");
      }
      else{
        changeIcon();
        $(this).addClass('class_test');
        $(this).find('i').attr('class', 'cs-icon icon-ios-minus-empty');
        $(this).parent().addClass('active_dropdown');
        $(this).parent().find('.menu-mobile-container').show("slow");
      }
    });
  }
  var showSubMenu = function(){
    $('.navigation_sub_mobile .arrow_sub_mobile').click(function(){
      if($(this).hasClass('class_test')){
        $(this).removeClass('class_test');
        $(this).find('i').attr('class', 'cs-icon icon-ios-plus-empty');
        $(this).parent().removeClass('active_dropdown');
        $(this).parent().find('.sub-menu-mobile-container').hide("slow");
      }
      else{
        $(this).addClass('class_test');
        $(this).find('i').attr('class', 'cs-icon icon-ios-minus-empty');
        $(this).parent().addClass('active_dropdown');
        $(this).parent().find('.sub-menu-mobile-container').first().show("slow");
      }
    });
  }
  var showShowInfo = function(){
    $('.icon_info .show-info').on('click', function() {
      $('#top .info-header').addClass('active');
      $('#top').attr("id","top-activeRight");
    });
    $('.info-header .close-info').on('click', function() {
      $('#top-activeRight').attr("id","top");
      $('#top').removeClass('affix fadeInDown animated');
      $('#top .info-header').removeClass('active');
      $('body,html').animate({scrollTop:0},1,'swing');
    });
  }
  showMenu();
  closeMenu();
  showMegaMenu();
  showSubMenu();
  showShowInfo();
}

function showItemMobile(){
  $('.item-dropdown-mobile .btn-group').on('click', '.dropdown-toggle', function() {
    $('.item-dropdown-mobile .dropdown-menu').css('display','none');

    if($(this).hasClass('active_popup')){
      $(this).removeClass('active_popup');
    }
    else{
      $('.item-dropdown-mobile .dropdown-toggle').removeClass('active_popup');
      $(this).addClass('active_popup');
      $('.item-dropdown-mobile').each(function(){
        if($(this).find('.dropdown-toggle').hasClass('active_popup')){
          $(this).find('.dropdown-menu').css('display','block');
        }
      });
    }
  });
}

function showPassword(){
  $(".form-password .cs-icon").on(clickEv, function() {
    if($(this).hasClass("show-pass")){
      $(this).parent().find("input").attr('type','password');
      $(this).removeClass("show-pass");
    }
    else{
      $(this).parent().find("input").attr('type','text');
      $(this).addClass("show-pass");
    }
  });
}

function sidebarBlog(){
  $(".sidebar-block .sidebar-title").on(clickEv, '.cs-icon', function() {
    if($(this).hasClass("show-content")){
      $(this).parents('.sidebar-block').find(".sidebar-content").show( "slow" );
      $(this).attr('class','cs-icon icon-ios-minus-empty');
    }
    else{
      $(this).parents('.sidebar-block').find(".sidebar-content").hide( "slow" );
      $(this).attr('class','show-content cs-icon icon-ios-plus-empty');
    }
  });
}

function tagFilterCollection(){
  var newQuery = '';
  var init = function(){
    Shopify.queryParams = {};
    if (location.search.length) {
      for (var aKeyValue, i = 0, aCouples = location.search.substr(1).split('&'); i < aCouples.length; i++) {
        aKeyValue = aCouples[i].split('=');
        if (aKeyValue.length > 1) {
          Shopify.queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
        }
      }
    }
  }
  var createUrl = function(url,queryParams){
    history.pushState({
      param: queryParams
    }, url, url);
    $.ajax({
      type: 'GET',
      url: url,
      data: {},
      beforeSend: function( xhr ) {
        $("#tags-load").show();
      },
      complete: function (data) {  
        $('#collection').html($("#collection", data.responseText).html());      
        $("#tags-load").hide();
        var urls = "\/\/productreviews.shopifycdn.com\/assets\/v4\/spr.js?shop=";
        $.getScript(urls, function() {
        });
        handleGridList();
        toggleTagsFilter();
        $(GLOBAL['common']['init']);
        filterClick();
        sidebarBlog();
        clearFilterMobile();
        applyFilterMobile();
        paginationCollection();
        showFilter();
        if(checkCollection == 1){
          removeFilter();
        }
      }
    });
  }
  var filterClick = function(){
    $('.filter-block .filter-content li > a').click(function(event) {
      event.preventDefault();
      var newTags = [];
      if (Shopify.queryParams.constraint) {
        newTags = Shopify.queryParams.constraint.split('+');
      }
      var dataHandle = $(this).parents('li').data("handle");
      if (dataHandle) {
        var tagCheck = newTags.indexOf(dataHandle);
        if (tagCheck >= 0) {
          newTags.splice(tagCheck, 1);
        } else {
          newTags.push(dataHandle);
        }
      }
      if (newTags.length) {
        Shopify.queryParams.constraint = newTags.join('+');
      } else {
        delete Shopify.queryParams.constraint;
      }
      delete Shopify.queryParams.page;
      newQuery = jQuery.param(Shopify.queryParams).replace(/%2B/g, '+');

      if(checkCollection == 1){
        if($(this).parents('li').hasClass('active')){
          $(this).parents('li').removeClass('active');
        }
        else{
          $(this).parents('li').addClass('active');
        }
      }
      else{
        if(getWidthBrowser() > 991 ){
          var url = location.pathname + "?" + newQuery;
          createUrl(url,Shopify.queryParams);
        }
        else{
          if($(this).parents('li').hasClass('active')){
            $(this).parents('li').removeClass('active');
          }
          else{
            $(this).parents('li').addClass('active');
          }
        }
      }
    });
  }
  var clearFilterMobile = function(){
    $('.collection-leftsidebar .sidebarMobile-clear').on(clickEv, function() {
      var url = '/collections/all' ;
      createUrl(url,url);
      $('#collection .collection-leftsidebar').removeClass('active-sidebar');
    });
  }
  var applyFilterMobile = function(){
    $('.sidebar-bottom .sidebarMobile-close').on(clickEv, function() {
      var url = location.pathname + "?" + newQuery;
      createUrl(url,Shopify.queryParam);
      $('.collection-leftsidebar').removeClass('active-sidebar');
    });
  }
  var paginationCollection = function(){
    $('.pagination-collection li a').on(clickEv, function(event) {
      event.preventDefault();
      var linkPage = $(this).attr("href").match(/page=\d+/g);
      if (linkPage) {
        Shopify.queryParams.page = parseInt(linkPage[0].match(/\d+/g));
        if (Shopify.queryParams.page) {
          newQuery = jQuery.param(Shopify.queryParams).replace(/%2B/g, '+');
		  var url = location.pathname + "?" + newQuery;
          createUrl(url,Shopify.queryParam);
        }
      }
    });
  }
  var removeFilter = function(){
    $('.collection-leftsidebar').removeClass('active');
    $('body').removeClass('active-sidebar');
  }
  var activeFilter = function(){
    $('.collection-leftsidebar').addClass('active');
    $('body').addClass('active-sidebar');
  }
  var showFilter = function(){
    $('.show-leftsidebar').on(clickEv, function() {
      if($('.collection-leftsidebar').hasClass('active')){
        removeFilter();
      }
      else{
        activeFilter();
      }
    });
    $('.close-leftsidebar').on(clickEv, function() {
      removeFilter();
    });
  }
  
  init();
  if(checkCollection != 0){
  filterClick();
  }
  clearFilterMobile();
  applyFilterMobile();
  paginationCollection();
  showFilter();
}

function handleAnimate(){
    
    $('[data-animate]').each(function(){
      
      var $toAnimateElement = $(this);
      
      var toAnimateDelay = $(this).attr('data-delay');
      
      var toAnimateDelayTime = 0;
      
      if( toAnimateDelay ) { toAnimateDelayTime = Number( toAnimateDelay ); } else { toAnimateDelayTime = 200; }
      
      if( !$toAnimateElement.hasClass('animated') ) {
        
        $toAnimateElement.addClass('not-animated');
        
        var elementAnimation = $toAnimateElement.attr('data-animate');
        
        $toAnimateElement.appear(function () {
          setTimeout(function() {
            $toAnimateElement.removeClass('not-animated').addClass( elementAnimation + ' animated');
          }, toAnimateDelayTime);
          
        },{accX: 0, accY: -100},'easeInCubic');
        
      }
    });
}

function addStickyScroll(scr,check){

  var offset_top_1 = $('#product-image').offset().top;
  var offset_top_2 = $('#product-information').offset().top;
  var hieght_as = $("#product-image").height();
  var hieght_affix_as = $('#product-information').height();
  var hieght = Math.ceil(offset_top_1 + hieght_as);
  var hieght_affix = Math.ceil(offset_top_2 + hieght_affix_as );

  var scrollTop = function(scr){
    if(scr > offset_top_1  && (scr+hieght_affix) < hieght){
      if(!$('#product-information').hasClass('affix-product')){
        $('#product-information').addClass('affix-product');
        $('#product-information').css({'top': '80px', 'height': 'auto'});
      }
    }
    else if( scr < offset_top_1 ){
      if($('#product-information').hasClass('affix-product')){
        $('#product-information').removeClass('affix-product');
        $('#product-information').css({'top': '0px', 'height': '100%'});
      }
    }
    else if( hieght_affix >= hieght ){
      if($('#product-information').hasClass('affix-product')){
        var top_px = (hieght_as - hieght_affix_as) + 'px';
        $('#product-information').removeClass('affix-product');
        $('#product-information').css({'top': top_px, 'height': '100%'});
      }
    }
  }
  var scrollBottom = function(scr){
    if(scr < offset_top_2 && scr > offset_top_1 ){
      if(!$('#product-information').hasClass('affix-product')){
        $('#product-information').addClass('affix-product');
        $('#product-information').css({'top': '80px', 'height': 'auto'});
      }
    }
    else if(scr < offset_top_1){
      if($('#product-information').hasClass('affix-product')){
        $('#product-information').removeClass('affix-product');
        $('#product-information').css({'top': '0px', 'height': '100%'});
      }
    }
    else if(scr > hieght){
      if($('#product-information').hasClass('affix-product')){
        var top_px = (hieght_as - hieght_affix_as) + 'px';
        $('#product-information').removeClass('affix-product');
        $('#product-information').css({'top': top_px, 'height': '100%'});
      }
    }
  }
  if(check == 1){
     scrollTop(scr);
  }
  if(check == 2){
     scrollBottom(scr);
  }
}

function isScrolledIntoView(elem) {
    var docViewTop = $(window).scrollTop();
    var docViewBottom = docViewTop + $(window).height();

    var elemTop = $(elem).offset().top;
    var elemBottom = elemTop + $(elem).height();

    return ((elemBottom <= docViewBottom) && (elemTop >= docViewTop));
}

function handleAddToCartButtonInMobile() {
    if ($(window).innerWidth() <= 767) {
        if (isScrolledIntoView($('#add-to-cart'))) {
            $('.add-to-cartMobile').addClass("fadeInOut hide-button").removeClass("fadeIn");
        } else {
            $('.add-to-cartMobile').addClass("fadeIn").removeClass("fadeInOut hide-button");
        }
    }
}


function videoProduct() {
  var heightVideo = function() {
    var height = 0;
    $('[data-product-single-media-wrapper]').each(function(index) {
      if(!$(this).hasClass('product-media-type-video')){
        height = $(this).find('[data-media-item]').height();
        $('.product-media-type-video').css('height', height);
        return false;
      }
    });
  }
  var clickThumbnail = function(player) {
    $('[data-product-thumbnail-id]').on(clickEv, function() {
      var thumbnailId = $(this).data('product-thumbnail-id');
      $('[data-product-thumbnail-id]').removeClass('active');
      $(this).addClass('active');
      
      if($('.product-single__media-wrapper.active').hasClass('product-media-type-video')){
        playVideo($('.product-single__media-wrapper.active'), player, 1)
      }
      if($('[data-media-id="'+thumbnailId+'"]').hasClass('product-media-type-video')) {
        playVideo($('[data-media-id="'+thumbnailId+'"]'), player, 2);
      }
      $('.product-single__media-wrapper.active').removeClass('active').addClass('hide');
      $('[data-media-id="'+thumbnailId+'"]').removeClass('hide').addClass('active');
    });
  }
  
  var playVideo = function($this, player, check) {
    var video = $this.find('[data-media-item]');
    if (video[0].tagName === 'VIDEO') {
      if (check == 1) {
        if (!video[0].paused) {
          video[0].pause();
        }
      } else {
        video[0].play();
      }
    } else if (video[0].tagName === 'IFRAME') {
      if (/^(https?:\/\/)?(www\.)?(youtube\.com|youtube-nocookie\.com|youtu\.?be)\/.+$/.test(video[0].src)) {
        var videoId = $this.data('video-id');
        if (check == 1) {
          if (player[videoId].getPlayerState() === 1) {
            player[videoId].pauseVideo();
          }
        } else {
          player[videoId].playVideo();
        }
      }
    }
  }
  if($('.product-single__media-wrapper').hasClass('product-media-type-video')){
    var tag = document.createElement('script');
    tag.src = 'https://www.youtube.com/player_api';
    var firstScriptTag = document.getElementsByTagName('script')[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    var player = {};
    window.onYouTubeIframeAPIReady = function() {
      $('[data-video-id]').each(function(index) {
        var video = $(this).find('[data-media-item]');
        var videoId = $(this).data('video-id');
        player[videoId] = new YT.Player(video[0], { // eslint-disable-line
          videoId,
        });
      });
      clickThumbnail(player);
    }
//     heightVideo();
  } else {
    clickThumbnail();
  }
}
$(window).scroll(function() {
  if(checkProduct == 1){
    handleAddToCartButtonInMobile();
  }
  if( checkProductV3 == 1 ){
    var scrollTop = $(this).scrollTop();
    var check = 0;
    if(scrollTop > checks_scroll){
      check = 1;
    }
    else if(scrollTop < checks_scroll){
      check = 2;
    }
    checks_scroll = scrollTop;
    addStickyScroll(scrollTop, check);
  }
});

$( window ).resize(function() {
  
  //handleDropdown();
  if( checkProductV3 == 1 ){
    var scrollTop = $(this).scrollTop();
    var check = 0;
    if(scrollTop > checks_scroll){
      check = 1;
    }
    else if(scrollTop < checks_scroll){
      check = 2;
    }
    checks_scroll = scrollTop;
    addStickyScroll(scrollTop, check);
  }
});

$(window).ready(function($) {
  
  handleDropdown();
  
  videoProduct();
  
  handleAnimate();
  
  tagFilterCollection();
  
  sidebarBlog();
  
  showPassword();
  
  showItemMobile();

  sliderProduct();
  
  sliderBlog();

  handleScrollTop();

  colorwarches();

  $('[data-toggle="tooltip"]').tooltip();

  handleQuantity();

  toggleTagsFilter();

  updateScrollThumbsQS();

  showMenuMobile();
});


$(window).load(function() { 
  
  

  ModalNewsletter();
  

});
